import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'
import { HelpCircle, Info } from 'lucide-react'
import { Alert, AlertDescription } from '@/common/ui/alert'

export default function BrokeFlexMessageHelp() {
	return (
		<Dialog>
			<DialogTrigger asChild>
				<Button variant="outline" size="sm">
					<HelpCircle className="mr-2 h-4 w-4" />
					คู่มือการใช้งาน
				</Button>
			</DialogTrigger>
			<DialogContent className="max-h-[80vh] max-w-3xl overflow-y-auto">
				<DialogHeader>
					<DialogTitle>คู่มือการสร้างแคมเปญข้อความเงินหมด</DialogTitle>
				</DialogHeader>

				<div className="space-y-6">
					<div>
						<h3 className="mb-2 text-lg font-semibold">
							แคมเปญข้อความเงินหมดคืออะไร?
						</h3>
						<p className="text-sm text-muted-foreground">
							เป็นระบบที่ส่งข้อความอัตโนมัติผ่าน LINE
							ให้กับผู้เล่นที่เงินหมดและยังไม่ฝากเงินเพิ่ม
							เพื่อแจ้งเตือนโปรโมชั่นและโบนัสที่พวกเขาสามารถรับได้
							เพื่อดึงดูดให้กลับมาเล่นอีกครั้ง
						</p>
					</div>

					<Alert>
						<Info className="h-4 w-4" />
						<AlertDescription>
							ระบบจะส่งข้อความเฉพาะรายการที่ผู้เล่นมีสิทธิ์รับเท่านั้น เช่น
							ถ้าไม่มียอดคืนยอดเสีย จะไม่แสดงรายการนั้น
						</AlertDescription>
					</Alert>

					<div>
						<h3 className="mb-3 text-lg font-semibold">รูปแบบแคมเปญที่มี</h3>
						<div className="space-y-4">
							<div className="rounded-lg border p-4">
								<h4 className="mb-2 flex items-center gap-2 font-medium">
									🎁 โปรโมชั่นเดี่ยว
								</h4>
								<p className="mb-2 text-sm text-muted-foreground">
									แนะนำสำหรับ: ส่งโปรโมชั่นเฉพาะ 1 รายการ
								</p>
								<ul className="ml-4 list-disc space-y-1 text-sm text-muted-foreground">
									<li>เหมาะกับโปรโมชั่นพิเศษหรือแบบ Hidden</li>
									<li>ง่ายต่อการตัดสินใจของผู้เล่น</li>
								</ul>
							</div>

							<div className="rounded-lg border p-4">
								<h4 className="mb-2 flex items-center gap-2 font-medium">
									🎯 โปรโมชั่นหลายรายการ
								</h4>
								<p className="mb-2 text-sm text-muted-foreground">
									แนะนำสำหรับ: แสดงโปรโมชั่นหลายรายการให้เลือก
								</p>
								<ul className="ml-4 list-disc space-y-1 text-sm text-muted-foreground">
									<li>แสดงได้สูงสุด 3 โปรโมชั่น</li>
									<li>ผู้เล่นเห็นทางเลือกที่หลากหลาย</li>
								</ul>
							</div>

							<div className="rounded-lg border p-4">
								<h4 className="mb-2 flex items-center gap-2 font-medium">
									💎 โปรโมชั่น + โบนัสกระเป๋า
								</h4>
								<p className="mb-2 text-sm text-muted-foreground">
									แนะนำสำหรับ: แสดงทั้งโปรโมชั่นและโบนัสที่มีในกระเป๋า
								</p>
								<ul className="ml-4 list-disc space-y-1 text-sm text-muted-foreground">
									<li>แสดงคืนยอดเสีย, ค่าคอม, โบนัสชวนเพื่อน</li>
									<li>เตือนผู้เล่นว่ายังมีเงินรอโอนได้</li>
								</ul>
							</div>

							<div className="rounded-lg border p-4">
								<h4 className="mb-2 flex items-center gap-2 font-medium">
									🎫 คูปองโปรโมชั่น
								</h4>
								<p className="mb-2 text-sm text-muted-foreground">
									แนะนำสำหรับ: ส่งคูปองพิเศษให้ผู้เล่น
								</p>
								<ul className="ml-4 list-disc space-y-1 text-sm text-muted-foreground">
									<li>เหมาะกับคูปองจำกัดจำนวน</li>
									<li>สร้างความพิเศษให้ผู้เล่น</li>
								</ul>
							</div>

							<div className="rounded-lg border p-4">
								<h4 className="mb-2 flex items-center gap-2 font-medium">
									🚀 ครบครัน (ทุกอย่าง)
								</h4>
								<p className="mb-2 text-sm text-muted-foreground">
									แนะนำสำหรับ: แสดงทุกสิ่งที่ผู้เล่นสามารถรับได้
								</p>
								<ul className="ml-4 list-disc space-y-1 text-sm text-muted-foreground">
									<li>รวมโปรโมชั่น + คูปอง + โบนัสทุกประเภท</li>
									<li>เหมาะกับผู้เล่น VIP</li>
								</ul>
							</div>
						</div>
					</div>

					<div>
						<h3 className="mb-2 text-lg font-semibold">
							การเพิ่มระยะการส่งข้อความ
						</h3>
						<p className="mb-3 text-sm text-muted-foreground">
							คุณสามารถเพิ่มระยะการส่งข้อความได้สูงสุด 4 ระยะ
							เพื่อติดตามผู้เล่นที่ยังไม่ฝากเงิน
						</p>
						<div className="space-y-2 text-sm">
							<div className="flex items-start gap-2">
								<span className="min-w-[80px] font-medium">ระยะที่ 1:</span>
								<span className="text-muted-foreground">
									ส่งทันทีเมื่อเงินหมด (0 นาที)
								</span>
							</div>
							<div className="flex items-start gap-2">
								<span className="min-w-[80px] font-medium">ระยะที่ 2:</span>
								<span className="text-muted-foreground">
									ส่งหลังจากผ่านไป 30 นาที (แนะนำ)
								</span>
							</div>
							<div className="flex items-start gap-2">
								<span className="min-w-[80px] font-medium">ระยะที่ 3:</span>
								<span className="text-muted-foreground">
									ส่งหลังจากผ่านไป 2 ชั่วโมง
								</span>
							</div>
							<div className="flex items-start gap-2">
								<span className="min-w-[80px] font-medium">ระยะที่ 4:</span>
								<span className="text-muted-foreground">
									ส่งหลังจากผ่านไป 1 วัน
								</span>
							</div>
						</div>
					</div>

					<Alert>
						<Info className="h-4 w-4" />
						<AlertDescription>
							<strong>เคล็ดลับ:</strong> เริ่มต้นด้วยรูปแบบง่ายๆ (ระยะเดียว)
							แล้วค่อยเพิ่มระยะการส่งเพิ่มเติมภายหลัง
							เพื่อดูผลการตอบสนองของผู้เล่น
						</AlertDescription>
					</Alert>
				</div>
			</DialogContent>
		</Dialog>
	)
}
